import { render, staticRenderFns } from "./Random.vue?vue&type=template&id=60407c64&"
import script from "./Random.vue?vue&type=script&lang=js&"
export * from "./Random.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports